import Vue from 'vue'
import extend from '@/utils/extend_vue_app'

const _connectWebsocket = () => {
  const url = process.env.NUXT_ENV_WS_URL
  if (!url) return

  const { localStorageTokenKey } = require('@/api_repository/repository')
  const ActionCableVue = require('actioncable-vue')
  const authHeader = localStorage.getItem(localStorageTokenKey)

  Vue.use(ActionCableVue, {
    debug: true,
    debugLevel: 'error',
    connectionUrl: url + '?token=' + authHeader,
    connectImmediately: true
  })
}

export default async function ({ app }) {
  extend(app, {
    beforeMount () {
      if(app.store.getters.isAuthenticated)
        _connectWebsocket()
    },
  })
}

Vue.prototype.$connectWebsocket = _connectWebsocket